import { module as Module } from 'modujs'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default class extends Module {
  constructor(m) {
    super(m)

    this.events = {
      click: 'click',
      mouseenter: 'show',
      mouseleave: 'hide',
    }
  }

  init() {
    this.args = {
      slug: this.el.dataset.slug,
      terms: this.el.dataset.terms,
    }
  }

  show() {
    this.call('show', this.args.slug, 'PostTitle')

    if (window.innerWidth >= 1200) {
      this.call('hoverAddActive', this.args.terms, 'Categories')
    }
  }

  hide() {
    this.call('hide', this.args.slug, 'PostTitle')

    if (window.innerWidth >= 1200) {
      this.call('hoverRemoveActive', '', 'Categories')
    }
  }

  click() {
    this.call('show', this.args.slug, 'PostTitle')
  }
}
